module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_02-19c05be4ee5d08ac1c2083fbc9e042ea.svg";